import React, { useEffect } from "react";
import { Button, Form, Space, Input, InputNumber } from "antd";
import {DollarOutlined, MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import { SettingInterface } from "src/store/community/settingsSlice";

interface propsInterface {
  onFinish: Function;
  params?: SettingInterface['data'] | undefined;
}

const _Products = ({ onFinish, params }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const ProductField = ({ name, remove, restField }) => (
    <Space style={{ display: 'flex', marginBottom: 2 }} align="baseline">
      <Form.Item
        {...restField}
        name={[name, 'product_id']}
        rules={[{ required: true, message: 'Missing product_id' }]}
      >
        <Input placeholder="com.example.100" />
      </Form.Item>

      <Form.Item
        {...restField}
        name={[name, 'value']}
        rules={[{ required: true, message: 'Missing value' }]}
      >
        <InputNumber
          min={0}
          step={50}
          placeholder="100"
        />
      </Form.Item>

      <MinusCircleOutlined onClick={() => remove(name)} />
    </Space>
  );

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      className='v-form'
      autoComplete="off"
      initialValues={params}
    >
      <Form.List name="products">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
                <ProductField
                  key={key}
                  name={name}
                  remove={remove}
                  restField={restField}
                />
              )
            )}

            <Form.Item>
              <Button
                type="dashed"
                onClick={add}
                block
                icon={<PlusOutlined />}
              >
                Add product
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Apply
        </Button>
      </Form.Item>
    </Form>
  );
}

export default _Products;
